import {
  getList,
} from "@surya-digital/leo-ts-types";
import { GroupAnswerElementV1, GroupAnswerElementV1DTO, GroupAnswerElementV1Enums } from "./groupAnswerElementV1";

export interface GroupAnswerV1DTO {
  answer: GroupAnswerElementV1DTO[];
}

export class GroupAnswerV1 {
  readonly isGroupAnswerV1GroupAnswerV1: boolean = true;

  readonly answer: GroupAnswerElementV1[];


  constructor(
  answer: GroupAnswerElementV1[]
  ) {
    this.answer = answer;
  }

  static fromDTO(dto: GroupAnswerV1DTO): GroupAnswerV1 {
    const answer = getList<GroupAnswerElementV1DTO, GroupAnswerElementV1>(
      dto,
      "answer",
      GroupAnswerElementV1.fromDTO,
      InvalidGroupAnswerV1AnswerError
    );
    return new GroupAnswerV1(
      answer
    );
  }

  toDTO(): GroupAnswerV1DTO {
    const dto: GroupAnswerV1DTO = {
        answer: this.answer.map((e: GroupAnswerElementV1) => { return e.toDTO() })
    };
    return dto;
  }
  }

GroupAnswerV1.prototype.toString = function toString(): string {
  return `GroupAnswerV1(answer='${this.answer}')`;
};

export class InvalidGroupAnswerV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerV1Error";
  }
}
export class InvalidGroupAnswerV1AnswerError extends InvalidGroupAnswerV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupAnswerV1AnswerError";
  }
}
